import { FGStack, FGTile, FGTypography } from '@fg/design-system';
import { IActiveDimension, IAPIActiveClientFacingIndicator } from 'interfaces';
import { first } from 'lodash/fp';
import { inject } from 'mobx-react';
import { getCFILongName, getDimensionLongName } from 'utils/riskUtils';
import rootStore, { IMobxRootState } from '../../RootStore';

type SingleRiskPickerPreviewProps = {
    dimensions?: { [dimensionId: number]: IActiveDimension };
    activeClientFacingIndicators?: IAPIActiveClientFacingIndicator;
    isClientFacingIndicators?: boolean;
    activeDimList?: number[];
};

const SingleRiskPickerPreview = inject(({ risksStore }: IMobxRootState) => {
    return {
        dimensions: risksStore.dimensions.hashed,
        activeClientFacingIndicators: risksStore.clientFacingIndicators,
        isClientFacingIndicators: risksStore.isClientFacingIndicators,
        activeDimList: risksStore.currentList,
    };
})((props: SingleRiskPickerPreviewProps) => {
    const {
        dimensions,
        activeClientFacingIndicators,
        isClientFacingIndicators,
        activeDimList,
    } = props;

    const risk = first(activeDimList);

    return (
        <FGTile
            padding="small"
            appearance="primary"
            onClick={() => {
                rootStore.risksStore.toggleRisk(risk);
            }}
            style={{ width: 'auto' }}>
            <FGStack alignItems="center">
                <FGTypography
                    tag="label"
                    variant="label3"
                    cssStyle={{ whiteSpace: 'nowrap' }}>
                    {isClientFacingIndicators
                        ? getCFILongName(activeClientFacingIndicators[risk])
                        : getDimensionLongName(dimensions[risk])}
                </FGTypography>
            </FGStack>
        </FGTile>
    );
});

export default SingleRiskPickerPreview;
